import styled from 'styled-components';
import './Div/index.js';
import { createStyleParser } from './Div/Div.js';
const textStylePropFunctions = {
  variant: v => ({
    fontSize: `var(--${v}-font-size)`,
    lineHeight: `var(--${v}-line-height)`,
    fontWeight: `var(--${v}-font-weight)`,
    fontFamily: `var(--${v}-font-family)`
  })
};
const styleFunction = createStyleParser(textStylePropFunctions);
const Text = styled.span(props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  const styles = styleFunction(props);
  if (!styles.display) styles.display = 'inline-flex';
  // TODO: reset CSS
  styles.margin = 0;
  return styles;
});
export { Text };
//# sourceMappingURL=Text.js.map
